import client from '../../../../lib/client';
import { constructParams } from '../../../../lib/helper';
import { ENDPOINT } from '../constants';
import { useRombel } from '../context';

function listRombel(params) {
  return client.get(`${ENDPOINT}${constructParams(params)}`);
}

function createRombel({
  name,
  code,
  idAcademicYears,
  idMajor,
  idClass,
  idStudents,
  homeRoomTeacher,
}) {
  return client.post(ENDPOINT, {
    name,
    code,
    idAcademicYears,
    idMajor,
    idClass,
    idStudents,
    homeRoomTeacher,
  });
}

function nextGradeRombel(payload) {
  return client.post(`${ENDPOINT}/next-grade`, payload);
}

function updateRombel({
  id,
  name,
  code,
  idAcademicYears,
  idMajor,
  idClass,
  idStudents,
  homeRoomTeacher,
}) {
  return client.put(`${ENDPOINT}/${id}`, {
    name,
    code,
    idAcademicYears,
    idMajor,
    idStudents,
    idClass,
    homeRoomTeacher,
  });
}

function showRombel(id) {
  return client.get(`${ENDPOINT}/${id}`);
}

function removeRombel(id) {
  const idRombel = id;
  return client.delete(`${ENDPOINT}/${idRombel}`);
}

function listStudent(args) {
  return client.get(
    'web-apps/dashboard-school/students-management?page=1&limit=1',
    {
      params: {
        ...args,
      },
    },
  );
}

function getStudentRombel(param) {
  const idRombel = param.id;
  return client.get(`${ENDPOINT}/${idRombel}/students`, {
    params: {
      ...param,
    },
  });
}

function getStudenNontRombel(param) {
  const idRombel = param.id;

  return client.get(
    `web-apps/dashboard-school/no-rombel/${idRombel}/students`,
    {
      params: {
        ...param,
      },
    },
  );
}

function addStudent(args) {
  return client.post(`${ENDPOINT}/${args.id}/students`, {
    ...args,
  });
}

function importStudent(args) {
  const idRombel = args?.id;
  return client.post(`${ENDPOINT}/${idRombel}/import`, { nisn: args?.data });
}

export {
  listRombel,
  importStudent,
  createRombel,
  updateRombel,
  showRombel,
  removeRombel,
  listStudent,
  addStudent,
  getStudentRombel,
  getStudenNontRombel,
  nextGradeRombel,
};
